import { imageSrc } from "@/lib/catalog";

// Imagem de campanha com versão para mobile (até 639px) e para desktop.
export const CollectionImage = ({ image, alt = "", className = "", eager = false, sizes = "100vw", style }) => {
  if (!image?.id) return null;
  const mobile = image.mobileId && image.mobileId !== image.id ? image.mobileId : null;
  return (
    <picture>
      {mobile && <source media="(max-width: 639px)" srcSet={`${imageSrc(mobile, 400)} 400w, ${imageSrc(mobile, 1200)} 1200w`} sizes="100vw" />}
      <img
        src={imageSrc(image.id, 1200)}
        srcSet={`${imageSrc(image.id, 400)} 400w, ${imageSrc(image.id, 1200)} 1200w`}
        sizes={sizes}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : undefined}
        className={className}
        style={style}
      />
    </picture>
  );
};
